export const REDUCER_PATH = 'clientFavorites';
